import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  BlacklistSchemasQuery,
  BlacklistSchemasQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { blacklistFragment } from "src/graphql/anti-fraud/fragments/BlacklistFragment";
import { useFetchQuery } from "src/graphql/utils/useFetchQuery.ts";
import { mapToClientSchemaBlacklist } from "src/mappers/clientSchema.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getBlacklistSchemasQuery = gql`
  query BlacklistSchemas {
    schema {
      blacklists {
        ...BlacklistFragment
      }
    }
  }

  ${blacklistFragment}
` as TypedDocumentNode<BlacklistSchemasQuery, BlacklistSchemasQueryVariables>;

export const useGetBlacklistSchemasQuery = (
  options?: QueryHookOptions<BlacklistSchemasQuery, BlacklistSchemasQueryVariables>
) => {
  return useFetchQuery(getBlacklistSchemasQuery, {
    queryOptions: options,
    toData: (data) => {
      return data?.schema?.blacklists?.map(mapToClientSchemaBlacklist) ?? [];
    },
    isEmpty: (data) => isEmpty(data?.schema?.blacklists),
    uiErrors: {
      fetchError: "FETCH-LIST-TYPES-ERROR",
      emptyError: "EMPTY-LIST-TYPES-ERROR",
    },
  });
};
